import React, {useEffect, useState} from 'react';
import './Notifications.css';
import NotificationTable from '../../components/NotificationTable/NotificationTable';
import BackButton from "../../components/BackButton/BackButton";

export default function Notifications(props) {
    const [currentUser, setCurrentUser] = useState();

    useEffect(() => {
        setCurrentUser(JSON.parse(localStorage.getItem("me")));
    }, []);

    return (

        <>
            <BackButton/>
            {currentUser && <NotificationTable currentUser={currentUser}/>}
        </>);
}